import Requester from '../../helpers/requester';
import { API_PATHS } from '../../helpers/endpoints';
import { HTTP_METHODS } from '../../helpers/constants';

export default {
  getCourierShiftReport: async (url, payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIER_SHIFT_REPORT}/${url}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCourierDistanceReport: async (url, payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.COURIER_DISTANCE_REPORT}?${url}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getOrderStatusReport: async (url, payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.ORDER_STATUS_REPORT}?${url}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  exportCourierDistanceReport: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.REPORT_EXPORT}/COURIER_DISTANCE_REPORT`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getEndOfDayReport: (payload) => {
    return Requester.submit({
      method: HTTP_METHODS.POST,
      url: API_PATHS.REPORTS_END_OF_DAY,
      data: payload,
    });
  },
};
